import React from "react";

const FlipCard = (props:any) => {

    const { children, flipped } = props;

    return (
        <div
            className={`product-list__item flip-card${flipped && " _flipped" || ""}`}
        >
            {children}
        </div>
    );
};

export default FlipCard;
